export default function messageOnGetCategoryById(status) {
    let message

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos pegar a categoria.'
            break
        case 401:
            message =
                'Ops! O seu tempo de acesso expirou, para continuar utilizando o sistema é necessário realizar o login.'
            break
        default:
            message = 'Ops! Algo de estranho ocorreu e não pegamos a categoria. Por favor, tente novamente mais tarde.'
    }
    return message
}
